import useLiveSymbolAvgPrice from "@shared/common/LiveComponents/useLiveSymbolAvgPrice";
import { EXCHANGES, ICON_TYPES } from "@shared/common/constants";
import usePricesSocket from "@shared/services/socket/usePricesSocket";
import React, { CSSProperties, useEffect } from "react";
import TextWithPrecisionAndIcon from "common/Text/TextWithPrecisionAndIcon";
import { DisplayCurrency } from "@shared/types";

interface LiveSymbolAvgPriceProps {
  symbol: string;
  initialPrice?: number;
  fontSize?: number;
  precision?: number;
  iconStyle?: CSSProperties;
  initialPriceTimestamp?: number;
  /** Shows the price in this currency instead of the display currency. */
  currency?: DisplayCurrency;
}

const LiveSymbolAvgPrice = ({
  symbol,
  initialPrice,
  fontSize,
  precision: propsPrecision,
  iconStyle,
  initialPriceTimestamp,
  currency,
}: LiveSymbolAvgPriceProps) => {
  const { currentAvgPrice, setPrice, precision, color } = useLiveSymbolAvgPrice(
    {
      symbol,
      initialPrice,
      precision: propsPrecision,
      initialPriceTimestamp,
      currency,
    }
  );

  return (
    <>
      {Object.values(EXCHANGES).map((exchange, index) => {
        return (
          <SocketPriceComponent
            key={index}
            symbol={symbol}
            exchange={exchange}
            currency={currency}
            setPrice={(price: number) => setPrice(price, index)}
          />
        );
      })}
      <TextWithPrecisionAndIcon
        text={currentAvgPrice}
        precision={precision}
        style={{ color, fontSize }}
        iconType={ICON_TYPES.DISPLAY_CURRENCY}
        iconStyle={iconStyle}
        currency={currency}
      />
    </>
  );
};

export default LiveSymbolAvgPrice;

interface SocketPriceComponentProps {
  symbol: string;
  exchange: string;
  currency?: DisplayCurrency;
  setPrice: (price: number) => void;
}

const SocketPriceComponent = ({
  symbol,
  exchange,
  currency,
  setPrice,
}: SocketPriceComponentProps) => {
  const { socketPrice } = usePricesSocket(symbol, exchange, currency);

  useEffect(() => {
    if (socketPrice.value) setPrice(socketPrice.value);
  }, [socketPrice]);

  return null;
};
